export const Environments = {
    LOCALHOST: 'LOCALHOST',
    DEVECOM: 'DEVECOM',
    DEVINTEG: 'DEVINTEG',
    DEVMAN: 'DEVMAN',
    DEVPOS: 'DEVPOS',
    DEVTECH: 'DEVTECH',
    DEV: 'DEV',
    QA: 'QA',
    NEXT: 'NEXT',
    TEST: 'TEST',
    PROD: 'PROD',
} as const;

export type Environment = (typeof Environments)[keyof typeof Environments];
